<template>
  <div class="md:flex bg-gray-200 md:w-full">
    <div class="md:w-full md:px-32">
      <router-view />
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      isVisible1: true,
      centralView: true,
      edit_menus: [],
      faq: false,
    };
  },
  mounted() {
    this.populateEditMenus();
    if (this.$route.params.customer_id && this.$route.params.contract_number) {
      localStorage.setItem("customer_id", this.$route.params.customer_id);
      localStorage.setItem(
        "contract_number",
        this.$route.params.contract_number
      );
    }
  },
  methods: {
    // to(item) {
    //   if (item.location != 1) {
    //     this.$router.push({
    //       name: "Edit Service",
    //       params: {
    //         service_id: item.id,
    //       },
    //     });
    //   } else {
    //     // sidebar menus
    //     if (!this.$route.path.includes(item.route)) {
    //       this.$router.push({
    //         name: item.name,
    //         params: {
    //           customer_id: this.$route.customer_id,
    //           contract_number: this.$route.contract_number,
    //         },
    //       });
    //       this.centralView = false;
    //     }
    //   }
    // },

    populateEditMenus() {
      axios.get("/menu/edit_menus").then((res) => {
        this.edit_menus = res.data.output;
        for (const item of this.edit_menus) {
          item.icon = require("@/assets/icons/" + item.icon);
        }
      });
    },
  },
};
</script>
